import React from 'react';
import Hero from '../components/Hero.jsx';
import { Stats, Testimonials, CallToAction } from '../components/Sections.jsx';
import AboutSection from '../components/AboutSection.jsx';
import OfferingsSection from '../components/OfferingsSection.jsx';
import WhatWeInvestIn from '../components/WhatWeInvestIn.jsx';
import PhilosophySection from '../components/PhilosophySection.jsx';
import Web3Section from '../components/Web3Section.jsx';
import DifferentiatorsSection from '../components/DifferentiatorsSection.jsx';
import RelationshipsSection from '../components/RelationshipsSection.jsx';

function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <AboutSection />
      <OfferingsSection />
      <WhatWeInvestIn />
      <PhilosophySection />
      <Web3Section />
      <DifferentiatorsSection />
      <RelationshipsSection />
      <Stats />
      <Testimonials />
      <CallToAction />
    </div>
  );
}

export default Home;
